import {Invoice} from '@eitje/api'
import {ftime} from '@eitje/utils'
import _ from 'lodash'

export const useInvoiceDateFilter = () => {
	const invoices = Invoice.useAll()

	const uniqueItems = _.orderBy(_.uniq(invoices._map('billing_date')), [], ['desc'])

	const dateItems = uniqueItems.map(date => ({
		id: date,
		value: ftime(date, 'dayMonthYear'),
	}))

	const filterFn = (item, filterValues) => {
		return filterValues.includes(item.billing_date)
	}

	return {
		items: dateItems,
		filterFn,
		labelField: 'value',
	}
}
